export default {
  amount: "Montant",
  motif: "Motif",
  addTitle: "Nouvelle dépense",
  removeWarning: "Etes-vous sûr de supprimer définitivement cette dépense ?",
  none: "Aucune dépense trouvée",
  filterByMotif: "Filtrer par motif",
  all: "Toutes dépenses",
};
